import { createFileRoute, notFound } from "@tanstack/react-router";
import { resolveExactAssetRouteParams } from "~/lib/exact-asset-route";

export const Route = createFileRoute("/_app/asset/$chainId/$tokenAddress")({
  params: {
    parse: (raw) => {
      const params = resolveExactAssetRouteParams(raw);
      if (!params) throw notFound();
      return params;
    },
  },
  head: () => ({ meta: [{ content: "noindex", name: "robots" }] }),
});
